const $ = require('jquery');
const _ = require("underscore");
import run from '../../utilities/run';
import render from "../../utilities/render";
import LookupTable from "../../components/lookupTable/index";
import { actionOptions } from "./filter/actionOptions.js";
import { searchDropdown } from "./filter/searchDropdown.js";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { prepareDataToSendController, doAjax, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import { handleCustomDropdownEvents } from "../../utilities/customBootstrapDropdowns";
require("./discountsLookup.less");

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let loaddiscountsDetailsLinkHtml = require("./html/discountsDetailsLink.html");

let els = {};
const elsMap = {
    exportBtn: ".export-btn"
}
let actionList = actionOptions;
const targetSelector = "#discounts-lookup";

const savedViews = [
    {
        title: "Default View",
        target: "alldiscounts",
        active: true,
        canRemove: false,
        canEdit: false,
        filters: [],
        columns: [
            {
                data: "discountsStatus",
                title: "Actions",
                active: true,
                canToggle: false
            },
           {
                data: "discountsName",
                title: "Name",
                active: true,
                canToggle: false
            },
            {
                data: "discountsStatus",
                title: "Status",
                active: true,
                canToggle: true
            },
            {
                data: "rtdMerchant",
                title: "Merchant",
                active: true,
                canToggle: true
            },
            {
                data: "modifiedDate",
                title: "Date Modified",
                active: true,
                canToggle: true
            },
            {
                data: "modifiedBy",
                title: "Modified By",
                active: true,
                canToggle: true
            },
            {
                data: "discountsId",
                title: "ID",
                active: true,
                canToggle: true
            }
        ]
    }
];

run(targetSelector, (mainEl) => {
    let targetObject = "";
    const dataTableComponentData = mainEl.data("discounts");
    const viewdiscountsDetailsPageUrl =mainEl.data("view-discounts-details-url");
    const portletNamespace = mainEl.data("portlet-namespace");
    const changediscountsStatusUrl = mainEl.data("change-status-url");
    const filterdiscountsUrl = mainEl.data("filter-discounts-url");
    const editdiscountsUrl = mainEl.data("edit-discounts-url");
    const isfinanceadmin = mainEl.data("isfinanceadmin");
    let deActivatediscountsModal = null;
    let activatediscountsModal = null;
    function renderDescription(data, type, item) {
        let result;
        let html;
        if (item.itmActive) {
            html = "<div class='q-marg-all-xs-at-md'>{%- data %}</div>";
            result = render(
                html, {
                    data: data
                }
            );
        } else {
            html = "<div class='q-marg-all-xs-at-md inactive-items'>{%- data %}</div>";
            result = render(
                html, {
                    data: data
                }
            );
        }
        return result;
    }

    function renderStatusPill(data, type, row) {
        if (data === 'Y') {
            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
        } else {
            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
        }
    }
    
	function renderActionWrap(data, type, row, meta) {
        if(row.discountsName == 'Default - All Merchants'){
           data = 'D';
        }
        
        //This logic is to hide the actions for user with CSS role
        if(isfinanceadmin == false){
            data = 'Z';
        }
        
        let newRender;
        let statusTarget = actionList[data];

        newRender = render(
            actionCellDropdownTemplate, {
                list: renderActionCellList(statusTarget),
                index: meta.row
            }
        );
        return newRender;
    };
	
	 function renderActionCellList(list, data, row) {
        let renderedList;
        renderedList = _(list).map((item) => {
            return render(
                actionCellDropdownItemTemplate, {
                    icon: item.icon,
                    title: item.title,
                    cls: item.cls,
                    disabled: false
                }
            );
        });
        return renderedList.join('');
    }

    function renderDetailLink(data, type, row,meta){
        return render(
            loaddiscountsDetailsLinkHtml,
            {
              discountsClassName: data,
              discountsId: row.discountsId,
              discountsParam:'discId',
              detailsPageUrl: viewdiscountsDetailsPageUrl,  
              portletNameSpace: portletNamespace
            }
        );
    }

    let discountsLookup = new LookupTable({
        
        target: $("#discounts-lookup-wrapper"),
        minWidthClass: "q-min-width-sm-til-md",
        mobileColumns: [

            {
                data: "discountsName",
                title: "discounts  Name",
                render: renderDescription,
                orderable: true,
            },
            {
                data: "discountsMerchant",
                title: "Merchants"
            }
        ],
		tableSearch: true,
        newSavedViews: true,
        tableSearchInput: {
            value: (targetObject != "" ? targetObject.value[0] : "")
        },
        tableSearchDropdown: {
            selected: (targetObject == "" ? "" : targetObject.key),
            columns: searchDropdown
        },
        savedViews: savedViews,
        bulkSelect: false,
        dataTable: {
            
            data: dataTableComponentData.content,
            columnDefs: [
                { className: "custom-class", targets: [1] }
            ],
            order: [
                [2, 'asc'],
            ],
            columns: [
                {
                    data: "discountsStatus",
                    title: "Actions",
                    render: renderActionWrap,
                    orderable: false,
                    class: 'dtc-action-column'
                },
                {
                    data: "discountsName",
                    title: "Name",
                    render: renderDetailLink,
                    class: 'dtc-min-width-md'
                },
				{
                    data: "discountsStatus",
                    title: "Status",
                    render: renderStatusPill,
                    class: 'dtc-min-width-sm'
                },
                {
                    data: "rtdMerchant",
                    title: "Merchant",
                    orderable: false,
                    class: 'dtc-min-width-md'
                },
               	{
                    data: "modifiedDate",
                    title: "Date Modified",               
                    class: 'dtc-min-width-sm'
                },
				{
                    data: "modifiedBy",
                    title: "Modified By",                 
                    class: 'dtc-min-width-sm'
                },
                {
                    data: "discountsId",
                    title: "ID",                 
                    class: 'dtc-min-width-sm lookupdiscountsId'
                }                	
            ]
        },
        paginationData: dataTableComponentData.page,        
        filterModal: {
            title: "Filter discounts",
            tableType: "discounts"
        },
        onFetch: function () {
            let currentData = discountsLookup.generateData();
            discountsLookup.showLoadingOverlay();
            if (isOnlyLookupDataUpdate(currentData)) {
                setTimeout(() => {
                    doAjax({ url: filterdiscountsUrl, success: filterSuccess, error: error, data: prepareDataToSendController(currentData) });
                }, SUCCESS_MODAL_TIMEOUT);
            }
            
        }
    });

handleCustomDropdownEvents();

$('body').on('click', '.deactivate-discounts', function (e) {
    
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    
    let row = table.row(parent);
    let deActivatediscountsModal = new SubmitModalFlow({
        confirmModalTitle: 'Deactivate Discounts',
        modalDialogClass: "q-modal-dialog-500",
        confirmModalBody: `<div class="q-pad-all-xl">Once deactivated, this discount will no longer be available for selected merchants. This discount can be reactivated at any time.</div>`,
        confirmModalBtnText: 'Deactivate Discounts',
        onConfirmClick: function () {
            deActivatediscountsModal.showLoadingModal();
            deactivatediscounts(row, row.data());
            function deactivatediscounts(row, discounts) {                 
                $.ajax({
                    url: changediscountsStatusUrl,
                    type: 'POST',
                    dataType: 'JSON',
                    data: {
                        discountsId: discounts.discountsId,
                        discountsStatus: 'N'                                
                    },
                    success: function (data) {                                                               
                        if (data.responseStatus === "Success") {   
                            let d = row.data();
                            d.discountsId=$.trim(data.discountsId);
                            d.discountsStatus=$.trim(data.discountsStatus);      
                            d.discountsName=$.trim(data.discountsName);
                            d.modifiedDate=$.trim(data.modifiedDate);
                            d.modifiedBy=$.trim(data.modifiedBy);         
                            row.data(d).draw();          
                            deActivatediscountsModal.showSuccessModal();                                                     
                            setTimeout(function () {                                                        
                                deActivatediscountsModal.hideAllModals();                                        
                            }, window.constants.SUCCESS_MODAL_TIMEOUT);
                        } else {                           
                            deActivatediscountsModal.showFailureModal();
                        }
                    },
                    error: function (data) {
                        deActivatediscountsModal.hideAllModals();
                    }
                });
            };
        }
    });    
    deActivatediscountsModal.init();
    deActivatediscountsModal.showConfirmModal();
});


$('body').on('click', '.activate-discounts', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
    let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    
    let row = table.row(parent);
    let activatediscountsModal = new SubmitModalFlow({
        confirmModalTitle: 'Activate Discounts',
        modalDialogClass: "q-modal-dialog-500",
        confirmModalBody: `<div class="q-pad-all-xl">Once activated, this discount will be available for selected merchants. This discount can be deactivated at any time.</div>`,
        confirmModalBtnText: 'Activate Discounts',
        onConfirmClick: function () {
            activatediscountsModal.showLoadingModal();
            activatediscounts(row, row.data());
            function activatediscounts(row, discounts) {   
                $.ajax({                   
                    url: changediscountsStatusUrl,
                    type: 'POST',
                    dataType: 'JSON',
                    data: {
                        discountsId: discounts.discountsId,
                        discountsStatus:  'Y'                               
                    },
                    success: function (data) {                                                             
                        if (data.responseStatus === "Success") {      
                            let d = row.data();
                            d.discountsId=$.trim(data.discountsId);
                            d.discountsStatus=$.trim(data.discountsStatus);      
                            d.discountsName=$.trim(data.discountsName);
                            d.modifiedDate=$.trim(data.modifiedDate);
                            d.modifiedBy=$.trim(data.modifiedBy);         
                            row.data(d).draw();   
                            activatediscountsModal.showSuccessModal();                          
                            setTimeout(function () {                      
                             activatediscountsModal.hideAllModals();                                        
                            }, window.constants.SUCCESS_MODAL_TIMEOUT);
                        } else {
                            activatediscountsModal.showFailureModal();
                        }
                    },
                    error: function (data) {
                        activatediscountsModal.hideAllModals();
                    }
                });
            };
        }
    });
    activatediscountsModal.init();
    activatediscountsModal.showConfirmModal();
});

    function init() {        
        $(".lookupdiscountsId").hide();
        setElements();
        bindElements();
    }

    function setElements() {
        setElementsFromScope(els, elsMap, mainEl);
    }

    function bindElements() {         
        
        $('body').on('click', '.edit-discounts', function (e) {
            e.preventDefault();
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            let row = table.row(parent);
            let discountsData = row.data();
            window.location.href = editdiscountsUrl+'&'+ portletNamespace+ 'discountsId='+ discountsData.discountsId +'&'+portletNamespace +'flow=edit';
        });


        $('body').on('click', '.duplicate-discounts', function (e) {
            e.preventDefault();
            let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
            let parent = $(".dropdown-parent-" + pIndex).parents('tr');
            let row = table.row(parent);
            let discountsData = row.data();
            window.location.href = editdiscountsUrl+'&'+ portletNamespace+ 'discountsId='+ discountsData.discountsId +'&'+portletNamespace +'flow=duplicate';
        });
    }

    function filterSuccess(data) {
        let discounts = data.content;
        let page = data.page;
        discountsLookup.setNewData(discounts);
        discountsLookup.setPaginationData(page);
        discountsLookup.hideLoadingOverlay();
        $(".lookupdiscountsId").hide();
    }

    function error() {
        discountsLookup.hideLoadingOverlay();
        $(".lookupdiscountsId").hide();
    }

    discountsLookup.init();
    let table = $("#discounts-lookup-wrapper .data-table-component").DataTable();
    init();   
    
  
}); 


// WEBPACK FOOTER //
// ./src/pages/discounts/lookup.js